// extracted by mini-css-extract-plugin
module.exports = {"container":"_c7e5d99","text":"_75cf4d0","title":"_8983d35"};